import React from "react";

import Table from "sulu-admin-bundle/components/Table";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";
import Icon from "sulu-admin-bundle/components/Icon";
import Toggler from "sulu-admin-bundle/components/Toggler";
import PassportCell from "../../ui/PassportCell";
import shirt from "../../../../../svgs/Shirt";

import style from "../../styles/player.module.scss";

const Option = SingleSelect.Option;

const { Row, Cell } = Table;

import { observer, inject } from "mobx-react";

const PlayerRow = inject("selectionStore")(
    observer(({ selectionStore, player, index, localState, disabled }) => {
        const isDisabled =
            !player.isStartingPlayer &&
            selectionStore.allPlayers.filter(
                (p) => p.team === player.team && p.isStartingPlayer,
            ).length >= selectionStore.numberOfStartingPlayers;

        return (
            <>
                <Row>
                    <Cell>{index + 1}</Cell>
                    <Cell>
                        <input
                            disabled={disabled}
                            className={style["player-number"]}
                            style={{
                                border:
                                    !player.number || player.number == "/"
                                        ? "1px solid red"
                                        : "1px solid #ccc",
                            }}
                            type="number"
                            value={!!player.number ? player.number : ""}
                            onChange={(e) =>
                                selectionStore.setNumber(
                                    player.contact,
                                    e.target.value,
                                )
                            }
                            inputMode="numeric"
                            min="1"
                            max="99"
                        ></input>
                    </Cell>
                    <Cell>{player.name}</Cell>
                    <Cell>
                        <PassportCell player={player} localState={localState} />
                    </Cell>
                    <Cell>{shirt({ isCore: player.core, fill: null })}</Cell>
                    <Cell>
                        <input
                            disabled={disabled}
                            style={{
                                cursor: "pointer",
                            }}
                            type="checkbox"
                            checked={player.isCaptain || false}
                            onChange={() =>
                                selectionStore.setCaptain(player.contact)
                            }
                        />
                    </Cell>
                    <Cell>
                        <input
                            disabled={disabled}
                            style={{
                                cursor: "pointer",
                            }}
                            type="checkbox"
                            checked={player.isGoalkeeper || false}
                            onChange={() =>
                                selectionStore.toggleGoalkeeper(player.contact)
                            }
                        />
                    </Cell>
                    <Cell>
                        <div
                            style={{
                                width: "10rem",
                            }}
                        >
                            <SingleSelect
                                disabled={disabled}
                                displayValue={"Choose position"}
                                name="positions"
                                value={player?.position}
                                onChange={(value) =>
                                    selectionStore.setPosition(
                                        player.contact,
                                        Number(value),
                                    )
                                }
                            >
                                {selectionStore.allPositions?.map(
                                    (position) => {
                                        return (
                                            <Option
                                                disabled={selectionStore.disabledPositions[
                                                    player.team
                                                ]?.includes(position.id)}
                                                key={position.id}
                                                value={position.id}
                                            >
                                                {position.name}
                                            </Option>
                                        );
                                    },
                                )}
                            </SingleSelect>
                        </div>
                    </Cell>

                    <Cell>
                        <Toggler
                            checked={player.isStartingPlayer}
                            disabled={isDisabled}
                            onChange={() =>
                                !disabled &&
                                selectionStore.toggleStartingPlayer(
                                    player.contact,
                                )
                            }
                        />
                    </Cell>
                    <Cell>
                        {!disabled && (
                            <div
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    selectionStore.removePlayer(player.contact)
                                }
                            >
                                <Icon name="su-trash-alt" />
                            </div>
                        )}
                    </Cell>
                </Row>
            </>
        );
    }),
);

export default PlayerRow;
